import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// @TODO: Make clear what we need about agent data

interface QueryParam {
  [key: string]: string
}
export interface routerState {
  pathname: string
  hash: string
  search: string
  queryParams: QueryParam
}
export const initialStateRouter: routerState = {
  pathname: '',
  hash: '',
  search: '',
  queryParams: {},
}

export const routerSlice = createSlice({
  name: 'router',
  initialState: initialStateRouter,
  reducers: {
    setLocation(state, action: PayloadAction<Partial<Location>>) {
      return { ...initialStateRouter, ...action.payload, queryParams: { ...state.queryParams } }
    },
    setQueryParams(state, action: PayloadAction<QueryParam>) {
      const { payload } = action
      return {
        ...state,
        queryParams: payload,
      }
    },
  },
})

export const { setLocation, setQueryParams } = routerSlice.actions

const routerReducer = routerSlice.reducer

export default routerReducer
